import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { IconButton, Tooltip } from "@mui/material";
import SettingToggleTextarea from "components/shared/SettingToggleTextarea";
import { useTranslation } from "react-i18next";
import type { AgreementTemplate } from "store/agreementsStore";

import styles from "./style.module.scss";

interface TemplateSignerBlockProps {
    template: AgreementTemplate;
    isEnabled: boolean;
    isExpanded: boolean;
    persistedValue: string;
    onToggle: (enabled: boolean) => void;
    onSave: (value: string) => void;
    onRemove: () => void;
    onSetExpanded: (val: boolean) => void;
}

const TemplateSignerBlock = ({
    template,
    isEnabled,
    isExpanded,
    persistedValue,
    onToggle,
    onSave,
    onRemove,
    onSetExpanded,
}: TemplateSignerBlockProps) => {
    const [t] = useTranslation();
    const hasSavedText = isEnabled && !!persistedValue.trim();

    return (
        <div className={styles["template-signer-block"]}>
            <div className={styles["template-signer-header"]}>
                <span className={styles["template-signer-name"]}>{template.name}</span>
                <div className={styles["template-signer-actions"]}>
                    {hasSavedText && (
                        <Tooltip title={t("ContractSettingsPreferences.PreviewText")}>
                            <IconButton size="small" onClick={() => onSetExpanded(!isExpanded)}>
                                <VisibilityOutlinedIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    )}
                    <Tooltip title={t("ContractSettingsPreferences.RemoveTemplate")}>
                        <IconButton size="small" onClick={onRemove}>
                            <DeleteOutlineOutlinedIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </div>
            </div>
            <SettingToggleTextarea
                title={t("ContractSettingsPreferences.SignerBlockTitle", { name: template.name })}
                description={t("ContractSettingsPreferences.SignerBlockDescription", { name: template.name })}
                enabled={isEnabled}
                persistedValue={persistedValue}
                onToggle={onToggle}
                onSave={onSave}
                rows={5}
                maxLength={500}
                expanded={isEnabled ? isExpanded : undefined}
            />
        </div>
    );
};

export default TemplateSignerBlock;
